import React, {useEffect, useState} from "react"


export const Test: React.FC = () => {
  const arr = new Array(10000).fill(1)
  return <ul style={{height: '99.9vh', overflow: 'scroll'}}>
    {arr.map((item, index) => <li>this is {index}</li>)}
  </ul>
}
